import { createApp } from 'vue'

/**
 * @note We only use Vue for the game since the Gravity Form injects
 * <script> tags into the page which will otherwise break Vue.
 */
const app = createApp({
  data() {
    return {
      currentTruthId: null,
      responseHeadline: null,
      responseContent: null,
      truths: window.culligan.truths || [],
    }
  },
  computed: {
    currentTruth() {
      if (this.currentTruthId) {
        return this.truths.filter((truth) => {
          return truth.id == this.currentTruthId
        })[0]
      }
    },
    isShowingResponse() {
      return this.responseHeadline != null
    },
    gameImageFilename() {
      if (this.currentTruth) {
        return this.currentTruth.image
      }

      return 'game-cover.jpg'
    },
  },
  methods: {
    start() {
      const id = this.truths[0].id
      if (id) {
        this.setTruth(id)
      }
    },
    setTruth(id) {
      this.currentTruthId = id
      this.responseHeadline = null
      this.responseContent = null
    },
    selectAnswer(response) {
      const currentTruth = this.currentTruth
      if (currentTruth) {
        this.responseContent = currentTruth.message
      }

      if (currentTruth && currentTruth.answer == response) {
        this.responseHeadline = 'Correct! The answer is ' + (currentTruth.answer ? 'True' : 'False') + '!'
      } else {
        this.responseHeadline = 'Nope, the answer is ' + (currentTruth.answer ? 'True' : 'False') + '!'
      }
    },
    scrollToForm() {
      scroll({
        top: document.querySelector('#form').offsetTop,
        behavior: "smooth"
      })
    },
  }
})

app.mount('#truth-about-water-game')
